// extracted by mini-css-extract-plugin
export default {"itemTitle":"Log_itemTitle__Su1xz","itemTimestamp":"Log_itemTimestamp__Vuvwr","listItem":"Log_listItem__zZoz1"};